module.exports = __webpack_public_path__ + "static/media/iconSunDark.3b650715.svg";